import { render, staticRenderFns } from "./DocumentsVerified.vue?vue&type=template&id=f73398d2&"
import script from "./DocumentsVerified.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DocumentsVerified.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f73398d2')) {
      api.createRecord('f73398d2', component.options)
    } else {
      api.reload('f73398d2', component.options)
    }
    module.hot.accept("./DocumentsVerified.vue?vue&type=template&id=f73398d2&", function () {
      api.rerender('f73398d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DocumentsVerified/DocumentsVerified.vue"
export default component.exports